// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__teMWT","inputWrap":"Table_inputWrap__gRSxl","col":"Table_col__2b1KS","bmiTooltip":"Table_bmiTooltip__2p7BD"};